(function ($) {
    'use strict';

    $(document).ready(function () {
        // moved to video-slider.js
    });
})(jQuery);